<template lang="pug">
    div.double-clock-container.l-flex-row--between.l-align-center
        el-select( 
            placeholder="Start"
            :value="startValue"
            @input="startValueChange"
        )
            el-option(
                v-for="hour of startInterval"
                :key="hour"
                :label="hour"
                :value="hour"

            )
        div.double-clock-connector 
            label To

        el-select(
            placeholder="End"
            :value="endValue" 
            @input="endValueChange"
        )
            el-option(
                v-for="hour of startInterval"
                :key="hour"
                :label="hour"
                :value="hour"
            )
    
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

export default {
    props: {
        value: {
            type: Array,
            required: true
        },
        minInterval: {
            type: Number,
            default: 1
        },
        maxInterval: {
            type: Number,
            default: 23
        }
    },

    data() {
        return {
            startInterval: Array.from({ length: 24 }, (_, i) => `0${i}:00`.slice(-5))
        }
    },

    computed: {
        startValue() {
            return this.value[0]
        },

        endValue() {
            return this.value[1]
        },

        minInt() {
            return this.minInterval > 0 && this.minInterval < 23 && this.minInterval < this.maxInterval ? this.minInterval : 0
        },

        maxInt() {
            return this.maxInterval > 0 && this.maxInterval <= 23 && this.maxInterval > this.minInterval ? this.maxInterval : 23
        }
    },

    methods: {
        startValueChange(startValue) {
            let endValue = this.endValue
            const startHour = dayjs(startValue, 'HH:mm')
            let endHour = dayjs(endValue, 'HH:mm')
            const minEndHour = startHour.add(this.minInt, 'hour')
            const maxEndHour = startHour.add(this.maxInt, 'hour')

            if (endHour.isBefore(startHour)) {
                endHour = endHour.add(1, 'day')
            }

            if (endHour.isBefore(minEndHour, 'hour')) {
                endValue = minEndHour.format('HH:mm')
                this.alertInputChange('end hour', 'minInt')
            }

            if (endHour.isAfter(maxEndHour, 'hour')) {
                endValue = minEndHour.format('HH:mm')
                this.alertInputChange('end hour', 'maxInt')
            }

            this.$emit('input', [startValue, endValue])
        },

        endValueChange(endValue) {
            let startValue = this.startValue
            let startHour = dayjs(startValue, 'HH:mm')
            const endHour = dayjs(endValue, 'HH:mm')
            const minStartHour = endHour.subtract(this.maxInt, 'hour')
            const maxStartHour = endHour.subtract(this.minInt, 'hour')

            if (startHour.isAfter(endHour)) {
                startHour = startHour.subtract(1, 'day')
            }

            if (startHour.isBefore(minStartHour, 'hour')) {
                startValue = minStartHour.format('HH:mm')
                this.alertInputChange('start hour', 'maxInt')
            }

            if (startHour.isAfter(maxStartHour, 'hour')) {
                startValue = minStartHour.format('HH:mm')
                this.alertInputChange('start hour', 'minInt')
            }

            this.$emit('input', [startValue, endValue])
        },

        alertInputChange(timePeriod, limit) {
            const limitString = {
                minInt: 'inferior',
                maxInt: 'superior'
            }

            this.$store.commit(
                'notifications/setAddedNotification',
                {
                    type: 'warning',
                    message: `We changed ${timePeriod} because range cannot be ${limitString[limit]} to ${this[limit]} hours`
                },
                { root: true }
            )
        }
    }
}
</script>
